{
  "nl": {
    "logged_out": {
      "success": {
        "login": "Opnieuw inloggen",
        "title": "Je sessie is beëindigd!"
      }
    }
  }
}
